module.exports = __webpack_public_path__ + "31617798e4908bb60a74423f916826d7.png";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Spotin_SymbolS_Ring_Off_White_Small_RGB.png
// module id = 288
// module chunks = 0